'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var cookieHelper = _interopDefault(require('../helpers/cookie-helper.js'));

// Cookie names
var subdomainCookieKey = 'subdomain';
var customerEmailCookieKey = 'customerEmail';
var lastShopCookieKey = 'last_shop';

function Cookies() {} // eslint-disable-line no-empty-function

Cookies.prototype.getSubdomain = function getSubdomain() {
  return cookieHelper.get(subdomainCookieKey) || this.getSubdomainFromLastShopCookie();
};

Cookies.prototype.getSubdomainCookie = function getSubdomainCookie() {
  return cookieHelper.get(subdomainCookieKey);
};

Cookies.prototype.getSubdomainFromLastShopCookie = function getSubdomainFromLastShopCookie() {
  var shop = cookieHelper.get(lastShopCookieKey);

  if (shop) {
    var matches = shop.match(/^([^.]+)\.myshopify\.com$/);

    if (matches) {
      return matches[1];
    }
  }

  return false;
};

Cookies.prototype.getCustomerEmailCookie = function getCustomerEmailCookie() {
  return cookieHelper.get(customerEmailCookieKey);
};

Cookies.prototype.enableLoginCookies = function enableLoginCookies(subdomain, login) {
  cookieHelper.set(subdomainCookieKey, subdomain, { path: '/' });
  cookieHelper.set(customerEmailCookieKey, login, { path: '/' });
};

Cookies.prototype.disableLoginCookies = function disableLoginCookies() {
  cookieHelper.set(subdomainCookieKey, '', { expires: new Date(0) });
  cookieHelper.set(customerEmailCookieKey, '', { expires: new Date(0) });
};

var cookies = new Cookies();

module.exports = cookies;
